export const UNIT_SIZE_FIELDS = [
  {
    id: "description",
    name: "description",
    label: "Description 📝",
    type: "text",
    placeholder: "Enter unit description",
  },
  {
    id: "width",
    name: "width",
    label: "Width 📏",
    type: "number",
    placeholder: "Enter width in meters",
  },
  {
    id: "length",
    name: "length",
    label: "Length 📐",
    type: "number",
    placeholder: "Enter length in meters",
  },
  {
    id: "unitCategoryId",
    name: "unitCategoryId",
    label: "Unit Category",
    type: "select",
    options: [],
  },
];

export const UNIT_SIZE_INITIAL_VALUES: Record<string, string> = {
  description: "",
  width: "",
  length: "",
  unitCategoryId: "",
};
